import { computed, watch, onBeforeUnmount, h } from 'vue';
import { createComponent } from './utils/create-component';
import propTypes from './utils/prop-types';
import { BLOCK_PREFIX } from './utils/constants';

var props = {
  /**
   * 根节点对应的 HTML 标签名
   */
  tag: propTypes.string().def('div'),
  /**
   * 自定义主题变量
   */
  themeVars: propTypes.object(),
  /**
   * 主题（default | business）
   */
  theme: propTypes.string().def('')
};
// 需要实现的事件列表，不需要可删除
var emits = [];

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

var _THEME_COLOR_CONFIG;
var DEFAULT_THEME = "".concat(BLOCK_PREFIX, "-default");
var BUSINESS_THEME = "".concat(BLOCK_PREFIX, "-business");
// 主题颜色配置信息
var THEME_COLOR_CONFIG = (_THEME_COLOR_CONFIG = {}, _defineProperty(_THEME_COLOR_CONFIG, DEFAULT_THEME, {
  light: 'var(--color-base-red-15)',
  dark: 'var(--color-base-red-17)'
}), _defineProperty(_THEME_COLOR_CONFIG, BUSINESS_THEME, {
  light: 'var(--color-base-blue-16)',
  dark: 'var(--color-base-blue-17)'
}), _THEME_COLOR_CONFIG);
// 主题名称
var THEME_NAME = '--color-theme-primary';
// 暗黑模式 class
var DARK_CLASS = "".concat(BLOCK_PREFIX, "-dark");

var _createComponent = createComponent('config-provider'),
  create = _createComponent.create,
  className = _createComponent.className;
/**
 * @description: 将传入的主题变量转为css变量
 * @param {*} themeVars
 * @param {*} any
 * @return {*}
 */
function mapThemeVarsToCSSVars(themeVars) {
  var cssVars = {};
  Object.keys(themeVars).forEach(function (key) {
    cssVars[key] = themeVars[key];
  });
  return cssVars;
}
var script = create({
  props: props,
  emits: emits,
  setup: function setup(props, _ref) {
    var slots = _ref.slots;
    var style = computed(function () {
      return props.themeVars ? mapThemeVarsToCSSVars(props.themeVars) : {};
    });
    /**
     * @description: 在 root 上设置样式
     * @param {*} root
     * @param {*} color
     * @return {*}
     */
    function setRootProperty(root, color) {
      root && root.style.setProperty(THEME_NAME, color);
    }
    /**
     * @description: 在 root 上添加主题样式
     * @param {*} theme
     * @return {*}
     */
    function addRootStyle(theme) {
      if (![DEFAULT_THEME, BUSINESS_THEME].includes(theme)) return;
      var isDark = document.body.classList.contains(DARK_CLASS);
      if (isDark) {
        var darkRoot = document.querySelector(":root .".concat(DARK_CLASS));
        setRootProperty(darkRoot, THEME_COLOR_CONFIG[theme].dark);
      } else {
        var root = document.querySelector(':root');
        setRootProperty(root, THEME_COLOR_CONFIG[theme].light);
      }
    }
    /**
     * @description: 移除 root 上的主题样式
     * @param {*} theme
     * @return {*}
     */
    function removeRootStyle() {
      var root = document.querySelector(':root');
      setRootProperty(root, '');
      var darkRoot = document.querySelector(":root .".concat(DARK_CLASS));
      setRootProperty(darkRoot, '');
    }
    watch(function () {
      return props.theme;
    }, function (newVal) {
      newVal && addRootStyle(newVal);
    }, {
      immediate: true
    });
    onBeforeUnmount(function () {
      // 组件销毁前清除主题样式
      removeRootStyle();
    });
    return function () {
      return h(props.tag, {
        "class": className,
        style: style.value
      }, slots["default"] && slots["default"]());
    };
  }
});

script.__file = "components/src/component/config-provider/config-provider.vue";

var _ConfigProvider = script;

export { _ConfigProvider as default };
